// assets/cart-discount-functionality.js

/**
 * Parodo grįžtamojo ryšio pranešimą vartotojui.
 * @param {string} message - Pranešimo tekstas.
 * @param {boolean} isError - Ar pranešimas yra klaidos tipo.
 */
function showDiscountFeedback(message, isError = false) {
  const feedbackElement = document.getElementById('discount-feedback-message');
  if (feedbackElement) {
    feedbackElement.textContent = message;
    feedbackElement.style.color = isError ? '#d9534f' : '#28a745';
  }
}

/**
 * Pritaikoma nuolaidų kodą naudojant Shopify Cart AJAX API.
 */
function applyDiscountCode() {
  const inputElement = document.getElementById('discount-code-input');
  const buttonElement = document.querySelector('.apply-button');
  const code = inputElement.value.trim();

  if (!code) {
    showDiscountFeedback('Prašome įvesti nuolaidų kodą.', true);
    return;
  }

  const originalButtonText = buttonElement.textContent;
  buttonElement.textContent = 'Taikoma...';
  buttonElement.disabled = true;
  showDiscountFeedback('');

  // Naudojame oficialų ir patikimą būdą atnaujinti krepšelį - per /cart/update.js
  // Siunčiame nuolaidų kodą JSON formatu.
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      discount: code
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Patikriname, ar Shopify grąžino klaidą.
    // Jei taip, parodome klaidos pranešimą ir NEPERKRAUNAME puslapio.
    if (cart.status === 422 || cart.message) {
      showDiscountFeedback(cart.description || 'Neteisingas arba negaliojantis nuolaidos kodas.', true);
      buttonElement.textContent = originalButtonText;
      buttonElement.disabled = false;
    } else {
      // Jei klaidų nėra, kodas pritaikytas sėkmingai.
      // Dabar perkrauname puslapį, kad teisingai atsinaujintų visos kainos.
      window.location.reload();
    }
  })
  .catch(error => {
    console.error('Įvyko netikėta klaida:', error);
    showDiscountFeedback('Sistemos klaida. Bandykite dar kartą vėliau.', true);
    buttonElement.textContent = originalButtonText;
    buttonElement.disabled = false;
  });
}

/**
 * Pridedame funkcionalumą, leidžiantį pritaikyti kodą paspaudus "Enter".
 */
document.addEventListener('DOMContentLoaded', function() {
  const inputElement = document.getElementById('discount-code-input');
  if (inputElement) {
    inputElement.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault(); // Svarbu, kad forma nebūtų submit'inama
        applyDiscountCode();
      }
    });
    
    // Prijungiame funkciją ir mygtuko paspaudimui
    const buttonElement = document.querySelector('.apply-button');
    if (buttonElement) {
        buttonElement.addEventListener('click', applyDiscountCode);
    }
  }
});
